import { GraphQLClient } from "graphql-request";
import { refreshAccessToken, isTokenExpired } from "./utils/tokenUtils";

const navigateHome = () => {
  if (window.location.pathname !== "/") {
    window.location.href = "/";
  }
};

export const graphQLClient = new GraphQLClient(
  import.meta.env.VITE_APP_GRAPHQL_ENDPOINT,
  {
    requestMiddleware: async (request) => {
      let accessToken = localStorage.getItem("id_token");

      if (isTokenExpired(accessToken)) {
        try {
          console.warn("Token expired, refreshing...");
          accessToken = await refreshAccessToken();

          if (!accessToken) throw new Error("No new token received");
        } catch (error) {
          if (
            !error.message.includes("No refresh token found in localStorage")
          ) {
            console.error("Failed to refresh access token:", request, error);
          }
          navigateHome();
          return Promise.reject(error);
        }
      }

      return {
        ...request,
        headers: {
          ...request.headers,
          authorization: accessToken ? `Bearer ${accessToken}` : "",
        },
      };
    },
    responseMiddleware: async (response) => {
      if (
        response.errors?.some(
          (err) =>
            err.message.includes("401") || err.message.includes("Unauthorized"),
        )
      ) {
        console.error("401 Unauthorized, logging out...");

        navigateHome();
      }
      return response;
    },
  },
);

// export const graphQLClient = new GraphQLClient(
//   import.meta.env.VITE_APP_GRAPHQL_ENDPOINT,
//   {
//     headers: () => ({
//       Authorization: `Bearer ${localStorage.getItem("id_token")}`,
//     }),
//   },
// );
